import { render, staticRenderFns } from "./list-class.vue?vue&type=template&id=28bb0e4c"
import script from "./list-class.vue?vue&type=script&lang=js"
export * from "./list-class.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/list/list.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports